import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconPlay: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.96 12.5012C1.64597 12.4993 1.33587 12.4312 1.05 12.3012C0.418562 12.0229 0.00803 11.4012 0 10.7112V2.29118V2.29119C0.00803011 1.60118 0.418557 0.979517 1.04999 0.701187C1.7758 0.358353 2.63356 0.459267 3.25999 0.961188L8.35999 5.17119C9.09453 5.75596 9.21594 6.82547 8.63117 7.56001C8.55129 7.66034 8.46032 7.75131 8.35999 7.83119L3.25999 12.0412C2.89237 12.3393 2.4333 12.5018 1.95999 12.5012L1.96 12.5012Z"
        fill="white"
      />
    </svg>
  </IconStyled>
);

IconPlay.defaultProps = iconDefaultProps;
IconPlay.displayName = 'IconPlay';

export default IconPlay;
